import Vue from "vue";
import Router from "vue-router";
import { Dialog } from "vant";
import md5 from "js-md5";
import store from "../vuex/store";

import Home from "@/pages/index";
import GoodsList from "@/pages/goods/index";
import Goodstype from "@/pages/goods/goodstype";
import Goods from "@/pages/goods/detail";
import User from "@/pages/user/index";
import Wxlogin from "@/pages/login/wxlogin";
// import Login from '@/pages/login/index'
import Login from "@/pages/login/notelogin";
import NoteLogin from "@/pages/login/index";
import Register from "@/pages/register/index";
import BackPass from "@/pages/backpass/index";
import AffirmOrder from "@/pages/affirmorder/index";
import OrderSucceed from "@/pages/affirmorder/ordersucceed";
import Cart from "@/pages/user/cart/cart";
import Collect from "@/pages/user/collect/collect";
import MyMoney from "@/pages/user/mymoney/mymoney";
import Money from "@/pages/user/mymoney/money";
import MyNews from "@/pages/user/mynews/mynews";
import News from "@/pages/user/mynews/news";
import MyOrder from "@/pages/user/myorder/myorder";
import AllOrder from "@/pages/user/myorder/allorder";
import FinishOrder from "@/pages/user/myorder/finishorder";
import PayOrder from "@/pages/user/myorder/payorder";
import SendOrder from "@/pages/user/myorder/sendorder";
import TakeOrder from "@/pages/user/myorder/takeorder";
import Order from "@/pages/user/myorder/order";
import MySite from "@/pages/user/mysite/mysite";
import MySites from "@/pages/user/mysite/mysites";
import AddSite from "@/pages/user/mysite/addsite";
import AmendSite from "@/pages/user/mysite/amendsite";
import Personal from "@/pages/user/personal/index";
import Buypoints from "@/pages/user/buypoints/index";
import Pointslist from "@/pages/user/buypoints/detail";
import Presented from "@/pages/user/presented/index";
import Pointsucceed from "@/pages/affirmorder/pointsucceed";
import Recharge from "@/pages/user/recharge/index";
import Nologin from "@/pages/user/recharge/nologin";
import Changename from "@/pages/user/personal/changename";
import Weixin from "@/pages/user/personal/weixin";
import Password from "@/pages/user/personal/password";
import Phone from "@/pages/user/personal/phone";
import History from "@/pages/user/history/index";
import Help from "@/pages/user/help/index";
import Helpdetail from "@/pages/user/help/detail";
import Feedback from "@/pages/user/help/feedback";
import Logistics from "@/pages/user/myorder/logistics";
import Count from "@/pages/activity/count";
import SignIn from "@/pages/activity/signin";
import Error from "@/pages/activity/error";
import Maintain from "@/pages/activity/maintain";
import Overtime from "@/pages/activity/overtime";
import Closed from "@/pages/activity/closed";
import Invite from "@/pages/activity/invite";
import Adventures from "@/pages/activity/adventures";
import HaveFun from "@/pages/activity/havefun";
import BrandGoods from "@/pages/goods/brandgoods";

// 兑换平台
import Eguide from "@/pages/exchange/guide";
import Elogin from "@/pages/exchange/login";
import Eindex from "@/pages/exchange/index";
import Edetail from "@/pages/exchange/detail";
import Eordercomit from "@/pages/exchange/ordercomit";
import Eaddsite from "@/pages/exchange/addsite";
import Eorder from "@/pages/exchange/order";
import Eorderlist from "@/pages/exchange/orderlist";
import Eordersucceed from "@/pages/exchange/ordersucceed";
import Elogistics from "@/pages/exchange/logistics";
import Over from "@/pages/exchange/over";


Vue.use(Router);
var root = process.env.API_ROOT;
const router = new Router({
  mode: "history",
  //ios缓存兼容
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.saveSrollTop) {
        from.meta.savedPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
      }
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  },
  routes: [
    // {path:'*',redirect:'/error'},
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/brandgoods",
      name: "BrandGoods",
      component: BrandGoods,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/havefun",
      name: "HaveFun",
      component: HaveFun,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/adventures",
      name: "Adventures",
      component: Adventures,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user/invite",
      name: "Invite",
      component: Invite,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/signin",
      name: "SignIn",
      component: SignIn,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/maintain",
      name: "Maintain",
      component: Maintain,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/overtime",
      name: "Overtime",
      component: Overtime,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/closed",
      name: "Closed",
      component: Closed,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "*",
      name: "Error",
      component: Error,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/count",
      name: "Count",
      component: Count,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/user/history",
      name: "History",
      component: History,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/personal",
      name: "Personal",
      component: Personal,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/personal/changename",
      name: "Changename",
      component: Changename,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/buypoints",
      name: "Buypoints",
      component: Buypoints,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/buypoints/detail",
      name: "Pointslist",
      component: Pointslist,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/presented",
      name: "Presented",
      component: Presented,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/pointsucceed",
      name: "Pointsucceed",
      component: Pointsucceed,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/recharge",
      name: "Recharge",
      component: Recharge,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/recharge/nologin",
      name: "Nologin",
      component: Nologin,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user/personal/weixin",
      name: "Weixin",
      component: Weixin,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/personal/phone",
      name: "Phone",
      component: Phone,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/personal/password",
      name: "Password",
      component: Password,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mynews/news",
      name: "News",
      component: News,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/user/cart",
      name: "Cart",
      component: Cart,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mynews",
      name: "MyNews",
      component: MyNews,
      // redirect: '/user/mynews/dealnews',
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },
    {
      path: "/user/collect",
      name: "Collect",
      component: Collect,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/myorder/logistics",
      name: "Logistics",
      component: Logistics,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/myorder",
      name: "MyOrder",
      component: MyOrder,
      redirect: "/user/myorder/allorder",
      meta: {
        keepAlive: false,
        requireAuth: true
      },
      children: [
        {
          name: "AllOrder",
          path: "allorder",
          component: AllOrder,
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          name: "PayOrder",
          path: "payorder",
          component: PayOrder,
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          name: "SendOrder",
          path: "sendorder",
          component: SendOrder,
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          name: "TakeOrder",
          path: "takeorder",
          component: TakeOrder,
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          name: "FinishOrder",
          path: "finishorder",
          component: FinishOrder,
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/user/myorder/order",
      name: "Order",
      component: Order,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mymoney",
      name: "MyMoney",
      component: MyMoney,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mymoney/money",
      name: "Money",
      component: Money,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mysite",
      name: "MySite",
      component: MySite,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mysites",
      name: "MySites",
      component: MySites,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/help",
      name: "Help",
      component: Help,
      meta: {
        keepAlive: true,
        requireAuth: true
      }
    },
    {
      path: "/user/helpDetail",
      name: "Helpdetail",
      component: Helpdetail,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/feedback",
      name: "Feedback",
      component: Feedback,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mysite/addsite",
      name: "AddSite",
      component: AddSite,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/user/mysite/amendsite",
      name: "AmendSite",
      component: AmendSite,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/ordersucceed",
      name: "OrderSucceed",
      component: OrderSucceed,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/affirmOrder",
      name: "AffirmOrder",
      component: AffirmOrder,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/backpass",
      name: "BackPass",
      component: BackPass,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/wxlogin",
      name: "Wxlogin",
      component: Wxlogin,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/notelogin",
      name: "NoteLogin",
      component: NoteLogin,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/goodstype",
      name: "Goodstype",
      component: Goodstype,
      meta: {
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: "/goodsList",
      name: "GoodsList",
      component: GoodsList,
      meta: {
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/goodsList/goods",
      name: "Goods",
      component: Goods,
      meta: {
        keepAlive: false, // 不需要缓存
        isBack: false
      }
    },
    {
      path: "/user",
      name: "User",
      component: User,
      meta: {
        keepAlive: false,
        requireAuth: true
      }
    },
    //兑换平台
    {
      path: "/eguide",
      name: "Eguide",
      component: Eguide,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/elogin",
      name: "Elogin",
      component: Elogin,
      meta: {
        keepAlive: false
      }
    },

    {
      path: "/eindex",
      name: "Eindex",
      component: Eindex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/edetail",
      name: "Edetail",
      component: Edetail,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/eordercomit",
      name: "Eordercomit",
      component: Eordercomit,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/eaddsite",
      name: "Eaddsite",
      component: Eaddsite,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/eorderlist",
      name: "Eorderlist",
      component: Eorderlist,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/eorder",
      name: "Eorder",
      component: Eorder,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/eordersucceed",
      name: "Eordersucceed",
      component: Eordersucceed,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/elogistics",
      name: "Elogistics",
      component: Elogistics,
      meta: {
        keepAlive: false,
        requireAuth1: true
      }
    },
    {
      path: "/over",
      name: "Over",
      component: Over,
      meta: {
        keepAlive: false
      }
    }
  ]
});
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(res => res.meta.requireAuth)) {// 判断是否需要登录权限
//     if (localStorage.getItem('BLHuser')) {// 判断是否登录
//       next()
//     } else {// 没登录则跳转到登录界面
//
//       Dialog.alert({
//         title: '提示 ',
//         message: '您还未登录是否去登录？'
//       }).then(() => {
//         router.push({name: 'Login'})
//
//
//       })
//     }
//   } else {
//     next()
//   }
// })

router.beforeEach((to, from, next) => {
  const url = window.location.href
  const nextRoutePopup = ['Login', 'Password']
  
  if(localStorage.getItem('isResetting') == 1 && nextRoutePopup.indexOf(to.name) == -1 && url.search('kmzhfl') != -1 ) {
    Dialog.confirm({
      title: "提示 ",
      message: "为了你的账号安全，请修改初始密码后在下单"
    })
      .then(() => {
        router.push({ name: "Password" });
      })
      .catch(() => {
        
      });
  }
  const nextRoute = [
    "User",
    "History",
    "Weixin",
    "AffirmOrder",
    "OrderSucceed",
    "MySite",
    "MySites",
    "AddSite",
    "AmendSite",
    "MyMoney",
    "Money",
    "MyOrder",
    "Order",
    "AllOrder",
    "PayOrder",
    "SendOrder",
    "TakeOrder",
    "FinishOrder",
    "Collect",
    "MyNews",
    "News",
    "Cart",
    "Password",
    "Personal",
    "Changename",
    "Logistics",
    "SignIn",
    "Invite",
    "Pointslist",
    "Recharge",
    "Buypoints"
  ];
  const nextRoute1 = [
    "Eordercomit",
    "Eordersucceed",
    "Eorderlist",
    "Elogistics",
    "Eorder",
    "Eaddsite",
    "Eordersucceed"
  ];
  const getUser = ["Home"];
  var isUser = localStorage.getItem("BLHuser");
  var mallid = localStorage.getItem("mallid");
  // var ts = new Date($.ajax({async: false}).getResponseHeader("Date"));
  var ts = new Date();
  ts = new Date(ts).getTime();
  ts = ts / 1000;
  var apiKey = "1106e4d408248208";
  var securityKey = "D5695EBCCF795D68";
  var gid = GetQueryString("gid");
  var sign = md5(
    md5("apiKey=" + apiKey + "securityKey=" + securityKey + "timeStamp=" + ts)
  );
  if (nextRoute.indexOf(to.name) >= 0) {
    // 未登录状态；当路由到nextRoute指定页时，跳转至login
    if (
      to.name != "NoteLogin" &&
      to.name != "BackPass" &&
      to.name != "Register"
    ) {
      store.commit("wapinfo");
    }
    store.commit("gonggao");
    // if (nextRoute.indexOf(to.name) >= 0) {
    document.getElementById("nothing").style.display = "block";
    if (store.state.user_id == "") {
      store.state.user_id = null;
    }
    $.ajax({
      type: "post",
      url: root + "/user/user/info",
      data: {
        id_example: mallid,
        token_user: isUser,
        timeStamp: ts,
        apiKey: apiKey,
        sign: sign
      },
      success: function(res) {
        if (typeof res == "string") {
          localStorage.setItem('isResetting', 0)
          if (JSON.parse(res).code == "-101") {
            Dialog.confirm({
              title: "提示 ",
              message: "您还未登录是否去登录？"
            })
              .then(() => {
                localStorage.setItem("routerUrl", to.name); //存储路由地址
                router.push({ name: "NoteLogin" });
                setTimeout(function() {
                  document.getElementById("nothing").style.display = "none";
                }, 500);
              })
              .catch(() => {
                window.history.go(-1);
                setTimeout(function() {
                  document.getElementById("nothing").style.display = "none";
                }, 500);
              });
          } else {
            Dialog.confirm({
              title: "提示",
              message: JSON.parse(res).message
            })
              .then(() => {
                window.history.go(-1);
                setTimeout(function() {
                  document.getElementById("nothing").style.display = "none";
                }, 500);
              })
              .catch(() => {
                window.history.go(-1);
                setTimeout(function() {
                  document.getElementById("nothing").style.display = "none";
                }, 500);
              });
          }
        } else if (res.code == "100") {
          localStorage.setItem('isResetting', res.data.is_reset_password)
          next();
          setTimeout(function() {
            document.getElementById("nothing").style.display = "none";
          }, 500);
        } else if (res.code == "-101") {
          localStorage.setItem('isResetting', 0)
          Dialog.confirm({
            title: "提示 ",
            message: "您还未登录是否去登录？"
          })
            .then(() => {
              localStorage.setItem("routerUrl", to.name); //存储路由地址
              router.push({ name: "NoteLogin" });
              setTimeout(function() {
                document.getElementById("nothing").style.display = "none";
              }, 500);
            })
            .catch(() => {
              window.history.go(-1);
              setTimeout(function() {
                document.getElementById("nothing").style.display = "none";
              }, 500);
            });
        } else {
          localStorage.setItem('isResetting', 0)
          Dialog.confirm({
            title: "提示",
            message: res.message
          })
            .then(() => {
              window.history.go(-1);
              setTimeout(function() {
                document.getElementById("nothing").style.display = "none";
              }, 500);
            })
            .catch(() => {
              window.history.go(-1);
              setTimeout(function() {
                document.getElementById("nothing").style.display = "none";
              }, 500);
            });
        }
      },
      error: function(err) {}
    });
  } else {
    next();
  }
  if (nextRoute1.indexOf(to.name) >= 0) {
    document.getElementById("nothing").style.display = "block";
    var isUser = localStorage.getItem("ECuser");

    if (isUser == undefined || isUser == null || isUser == "") {
      Dialog.confirm({
        title: "提示 ",
        message:
          isUser == null ? "您还未登录是否去登录？" : "用户登陆失效请重新登陆"
      })
        .then(() => {
          var url = to.name;
          url == "Eorder" ? (url = "Eindex") : (url = url);
          localStorage.setItem("routerUrl1", url); //存储路由地址
          router.push({ name: "Elogin", query: { gid: gid } });
          setTimeout(function() {
            document.getElementById("nothing").style.display = "none";
          }, 500);
        })
        .catch(() => {
          window.history.go(-1);
          setTimeout(function() {
            document.getElementById("nothing").style.display = "none";
          }, 500);
        });
    } else {
      next();
      setTimeout(function() {
        document.getElementById("nothing").style.display = "none";
      }, 500);
    }
  } else {
    next();
  }
  if (to.name == "Recharge") {
    if (store.state.webInfo.card_status == 0) {
      router.push({ name: "Error" });
      return false;
    }
    // next()
  }
});
function GetQueryString(name) {
  //获取url
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg); //search,查询？后面的参数，并匹配正则
  if (r != null) return unescape(r[2]);
  return null;
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js